import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { redirectToApp } from '@/utils/domainDetection';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // If not loading and no user, redirect to login
    if (!loading && !user) {
      console.log('[ProtectedRoute] No user found, redirecting to login');
      // Only preserve redirect if it's not the login page itself
      // This prevents redirect loops and unwanted redirects after logout
      if (location.pathname !== '/entrar' && location.pathname !== '/') {
        const returnUrl = encodeURIComponent(location.pathname + location.search);
        redirectToApp(`/entrar?redirect=${returnUrl}`);
      } else {
        redirectToApp('/entrar');
      }
    }
  }, [loading, user, location]);

  // Show simple blue spinner for both loading and redirecting states
  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 text-primary animate-spin" />
      </div>
    );
  }

  return <>{children}</>;
}